import React from 'react';
import PropTypes from 'prop-types';
import './BlueButton.scss';

const BlueButton = (props) => (
    <button className="blue-button" onClick={props.clickevent}>{props.text}</button>
);

BlueButton.propTypes = {
    text: PropTypes.string,
    clickevent: PropTypes.any
};

BlueButton.defaultProps = {
    text: "Login with Password",
    clickevent: {}
};

export default BlueButton;
